import { ActionType } from "../interfaces/api/actionType";

export const GetSectors: ActionType = {
  FAILURE: "GET_SECTORS_FAILURE",
  REQUEST: "GET_SECTORS_REQUEST",
  SUCCESS: "GET_SECTORS_SUCCESS",
};
